import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=53b2bee4&scoped=true"
import script from "./HomeCarousel.vue?vue&type=script&lang=ts"
export * from "./HomeCarousel.vue?vue&type=script&lang=ts"
import style0 from "./HomeCarousel.vue?vue&type=style&index=0&id=53b2bee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2bee4",
  null
  
)

export default component.exports